import axios from './axios'
import {post,get} from './axios'
import { Message } from 'element-ui'

export default{
    //获取委托方
    OpenEntrusts: () =>{
        return get('/osapi/Entrusts/dlist')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //资产版-获取资产-委托方
    OpenZcEntrusts: () =>{
        return get('/fapi/Aventrusts/zc_dlist')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
        .catch(error => {
            Message({
                message: '网络连接错误,请稍后重试!',
                type: 'error'
            });
        })
    },
    
    //获取主账号下所有的委托方
    OpenentrustAll: () =>{
        return get('/osapi/Entrusts/entrustAll')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取批次号
    AllgetBills: () =>{
        return get('/osapi/Batch/bills')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取批次号/委托方
    getEntrustBill: (is_all) =>{
        return get('/osapi/Cases/searchEntrustBill',{
            is_all: is_all ? is_all : ''
        })
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取催收员
    memNodes: () =>{
        return get('/Fapi/Member/memNodes')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取催收员--穿梭框
    memNodeList: () =>{
        return get('/Fapi/Member/memNodeList')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取催收员--穿梭框--只获取债权事业管理中心数据
    claimNodeList: () =>{
        return get('/osapi/Member/claimNodeList')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取地区
    CityArea: () =>{
        return get('/osapi/Cases/caseArea')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
    },

    //获取省市
    getProAndCity: () => {
        return get('/osapi/cases/caseAreas')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                mymessage({
                    message: msg,
                    type: "error"
                });
                return false
            } else {
            	return data
            }
        }).catch(() => {
            return false
        })
    },

    //获取发函模板列表（发函权限模板下拉）
    getTplList: () => {
        return get('/Fapi/multi_lawyer/tpl_list')
        .then( res => {
            let { code , msg } = res.data;
            if(code !== 1){
                Message({
                    message: msg,
                    type: 'error'
                })
            } else {
                return res
            }
        })
    },

    //获取催收状态
    getnoteLinkage: () => {
        return get('/osapi/Config/noteLinkage')
        .then( res => {
            let { code , msg } = res.data;
            if(code !== 1){
                Message({
                    message: msg,
                    type: 'error'
                })
            } else {
                return res
            }
        })
    },

    //获取发函模板列表（发函权限模板下拉）
    getTplList: () => {
        return get('/fapi/multi_lawyer/tpl_list')
        .then( res => {
            let { code , msg } = res.data;
            if(code !== 1){
                Message({
                    message: msg,
                    type: 'error'
                })
            } else {
                return res
            }
        })
    },

    //获取当前主账号下已关联的模板列表   
    getTplListCurr: (id) => {
        return get('/fapi/multi_lawyer/apply_auth_tpl',{
            entrust_id: id,
        })
        .then( res => {
            let { code , msg } = res.data;
            if( code !== 1){
                Message({
                    message: msg,
                    type: 'error'
                })
            } else {
                return res
            }
        })
    },
    
    //获取角色
    Role: () =>{
        return get('/osapi/Auth/dlist')
        .then(res =>{
            let { msg, code, data } = res.data;
            if (code !== 1) {
                Message({
                    message: msg,
                    type: "error"
                });
            } else {
            	return res
            }
        })
        .catch(error => {
            Message({
                message: '网络连接错误,请联系管理员!',
                type: 'error'
            });
        })
    },

    //获取债权事业管理部及其下属部门
    getClaimDepart() {
        return new Promise( resolve => {
            get('/osapi/Depart/side')
            .then( res=>{
                let { msg, code, data } = res.data;
                if (code !== 1) {
                    this.$message({
                        message: msg,
                        type: "error"
                    });
                    return false
                } else {
                    resolve(res.data)
                }
            })
        })
    },
    //获取安全设置
    getSafeSet: (type) => { //1水印设置 2禁止复制 3标签设置 4录音下载 0获取所有设置
        return new Promise( (reslove, reject) => {
            get('/osapi/Safesetting/getSetting',{
                type: type
            }).then( res => {
                reslove(res.data)
            }).catch( error => {
                reslove({
                    code: 0,
                    msg: '服务器繁忙，请稍后再试',
                    data:[]
                })
            })
        })
    },
    //给标签赋予颜色
    tagStorage: (data) => {
        return new Promise ( (reslove, reject) => {
            var colors= ['#DD0527','#F6902F','#9FDF13','#1B76B1','#9005F5','#6A5660']; //标签颜色
            var tagobj = {};
            for (let index = 0; index < data.length; index++) {
                tagobj[data[index].name] = data[index];
                tagobj[data[index].name].color = colors[index]
            }
            reslove({
                code: 1,
                msg: 'success',
                data: tagobj
            })
        }) 
            
    }
}


// WEBPACK FOOTER //
// ./src/api/common.js